import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5dade4f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  viewBox: "-10 -10 120 120",
  class: "initials"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "55"
}, null, -1))
const _hoisted_3 = {
  x: "50",
  y: "54"
}

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  findIconDefinition,
  IconPrefix,
  IconName,
} from "@fortawesome/fontawesome-svg-core";
import InlineSvg from "vue-inline-svg";
import { computed } from "vue";

interface Props {
  /**
   * kebab-case name of icon to show. for font awesome, without fas/far/etc
   * prefix. for custom icon, match filename, without extension.
   */
  icon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppIcon',
  props: {
    icon: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * kebab-case name of icon to show. for font awesome, without fas/far/etc
   * prefix. for custom icon, match filename, without extension.
   */
  icon?: string;
}



/** find custom icon with matching name, if there is one */
const custom = computed((): string => {
  try {
    return require(`@/assets/icons/${props.icon}.svg`);
  } catch (error) {
    return "";
  }
});

/** find font awesome icon with matching name, if there is one */
const fa = computed(() => {
  for (const prefix of ["fas", "far", "fab"]) {
    const match = findIconDefinition({
      prefix: prefix as IconPrefix,
      iconName: props.icon as IconName,
    });
    if (match) return match;
  }

  return null;
});

/** initials as fallback */
const initials = computed(() =>
  props.icon
    ?.replace(/^category-/, "")
    .split("-")
    .map((word) => (word[0] || "").toUpperCase())
    .join("")
);

return (_ctx: any,_cache: any) => {
  return (_unref(custom))
    ? (_openBlock(), _createBlock(_unref(InlineSvg), {
        key: 0,
        src: _unref(custom),
        class: "icon",
        "aria-hidden": "true",
        "data-icon": __props.icon
      }, null, 8, ["src", "data-icon"]))
    : (_unref(fa))
      ? (_openBlock(), _createBlock(_unref(FontAwesomeIcon), {
          key: 1,
          icon: _unref(fa),
          "data-icon": __props.icon,
          "aria-hidden": "true"
        }, null, 8, ["icon", "data-icon"]))
      : (_unref(initials))
        ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("text", _hoisted_3, _toDisplayString(_unref(initials)), 1)
          ]))
        : _createCommentVNode("", true)
}
}

})